export const ORIGIN_ADDRESS = 'originAddress';
export const RETURN_ADDRESS = 'returnAddress';
export const REQUIRES_EMAIL = 'requiresEmail';
export const DEFAULTS = {
  validation: {
    helperText: '',
    helperTextType: '',
  },
};
